import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "duplicate-virtual-devices"
  }, [_c(VDataIterator, {
    attrs: {
      "items": _vm.twinCopiesData,
      "items-per-page": _vm.itemsPerPage,
      "options": _vm.tableOptions,
      "footer-props": _vm.tableFooterProps,
      "page": _vm.tableOptions.page,
      "hide-default-header": ""
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('span')];
      },
      proxy: true
    }, {
      key: "default",
      fn: function (props) {
        return [_c(VRow, {
          staticClass: "ma-0 pa-0"
        }, _vm._l(props.items, function (item, i) {
          return _c(VCol, {
            key: `item_${i}`,
            staticClass: "d-flex justify-space-between ma-0 pa-1",
            staticStyle: {
              "max-width": "25%"
            }
          }, [_c('core-n20Card', {
            class: `dt-card-text-01 my-3`,
            attrs: {
              "border": `1px solid ${_vm.errornousParentId === item.parentId ? 'red' : 'transparent'}`
            }
          }, [_c('h4', {
            class: `${_vm.color}--text mb-0`
          }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.detailsHeadline')) + "\n            ")]), _c(VRow, [_vm.errornousParentId === item.parentId ? _c(VCol, {
            staticClass: "mt-0 pt-0 pt-2 danger--text",
            attrs: {
              "cols": "12"
            }
          }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.noPermissionsOnParent')) + "\n              ")]) : _vm._e(), _c(VCol, {
            staticClass: "py-1",
            attrs: {
              "cols": "12"
            }
          }, [_c(VTextField, {
            attrs: {
              "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle'),
              "placeholder": _vm.titlePlaceholder,
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "hide-details": "auto",
              "clearable": ""
            },
            model: {
              value: item.title,
              callback: function ($$v) {
                _vm.$set(item, "title", $$v);
              },
              expression: "item.title"
            }
          })], 1), _c(VCol, {
            staticClass: "py-1",
            attrs: {
              "cols": "12"
            }
          }, [_vm.globalParentId === false ? [_c('core-dtwin-finder', {
            ref: `twin-finder-${item.id}`,
            refInFor: true,
            attrs: {
              "objectFilter": _vm.twinParentFilter,
              "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
              "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
              "tenantId": _vm.orgTwin.tenantId,
              "required": "",
              "sameTenant": "",
              "hideDetails": ""
            },
            model: {
              value: item.parentId,
              callback: function ($$v) {
                _vm.$set(item, "parentId", $$v);
              },
              expression: "item.parentId"
            }
          })] : [_c(VTextField, {
            attrs: {
              "value": `${_vm.globalParentTwin.title} (ID: ${_vm.globalParentTwin.id})`,
              "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
              "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "hide-details": "",
              "disabled": "",
              "readonly": ""
            }
          })]], 2), _vm.metaInfoToggles['tags'] ? _c(VCol, {
            staticClass: "py-1",
            attrs: {
              "cols": "12"
            }
          }, [_c('core-tags', {
            attrs: {
              "tags": _vm.get(item, 'data.tags', [])
            },
            on: {
              "update:tags": updatedTags => _vm.updateTags(updatedTags, item)
            }
          })], 1) : _vm._e(), _vm.metaInfoToggles['address'] ? _c(VCol, {
            staticClass: "py-1",
            attrs: {
              "cols": "12"
            }
          }, [_c(VTextField, {
            attrs: {
              "label": _vm.$i18n_t('Common.address'),
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "hide-details": "auto",
              "clearable": ""
            },
            model: {
              value: item.data.address.formatted_address,
              callback: function ($$v) {
                _vm.$set(item.data.address, "formatted_address", $$v);
              },
              expression: "item.data.address.formatted_address"
            }
          })], 1) : _vm._e(), _vm.metaInfoToggles['geocoordinates'] ? _c(VCol, {
            staticClass: "py-1",
            attrs: {
              "cols": "12"
            }
          }, [_c(VTextField, {
            attrs: {
              "label": _vm.$i18n_t('Common.lat'),
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "rules": _vm.ruleValidateCoordinates(item.coordinates.coordinates[1]),
              "hide-details": "auto",
              "clearable": ""
            },
            on: {
              "input": function ($event) {
                return _vm.formatLonLat(item.coordinates.coordinates, 1);
              },
              "change": function ($event) {
                return _vm.handleCoordinateChange(item);
              }
            },
            model: {
              value: item.coordinates.coordinates[1],
              callback: function ($$v) {
                _vm.$set(item.coordinates.coordinates, 1, $$v);
              },
              expression: "item.coordinates.coordinates[1]"
            }
          })], 1) : _vm._e(), _vm.metaInfoToggles['geocoordinates'] ? _c(VCol, {
            staticClass: "py-1",
            attrs: {
              "cols": "12"
            }
          }, [_c(VTextField, {
            attrs: {
              "label": _vm.$i18n_t('Common.lon'),
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "rules": _vm.ruleValidateCoordinates(item.coordinates.coordinates[0]),
              "hide-details": "auto",
              "clearable": ""
            },
            on: {
              "input": function ($event) {
                return _vm.formatLonLat(item.coordinates.coordinates, 0);
              },
              "change": function ($event) {
                return _vm.handleCoordinateChange(item);
              }
            },
            model: {
              value: item.coordinates.coordinates[0],
              callback: function ($$v) {
                _vm.$set(item.coordinates.coordinates, 0, $$v);
              },
              expression: "item.coordinates.coordinates[0]"
            }
          })], 1) : _vm._e(), _vm.metaInfoToggles['keyvalue'] ? _c(VCol, {
            staticClass: "py-1",
            attrs: {
              "cols": "12"
            }
          }, [_c('h4', {
            class: `${_vm.color}--text mb-0`
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.keyValue')) + "\n                ")]), _c('core-dtwin-key-value-editor', {
            attrs: {
              "twinObject": item,
              "hasTwinEditPermission": "",
              "dense": "",
              "oneColLayout": ""
            }
          })], 1) : _vm._e(), _vm.metaInfoToggles['referenceIds'] ? _c(VCol, {
            staticClass: "py-1",
            attrs: {
              "cols": "12"
            }
          }, [_c('h4', {
            class: `${_vm.color}--text mb-0`
          }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.referenceIds.headline')) + "\n                ")]), _c('core-dtwin-reference-ids', {
            attrs: {
              "value": _vm.cloneDeep(item['dynamical-data-routing-destination']) || [],
              "keyLabel": _vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.referenceIdName'),
              "valueLabel": _vm.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.referenceIdValue'),
              "singleColumn": ""
            },
            on: {
              "update": updatedValue => _vm.handleUpdate(updatedValue, i)
            }
          })], 1) : _vm._e()], 1), _vm.loadingStates || _vm.pickableStates.length ? _c('h4', {
            class: `${_vm.color}--text mb-0`
          }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataStates')) + "\n            ")]) : _vm._e(), _vm.loadingStates ? _c(VRow, [_c(VCol, {
            staticClass: "mt-2 mb-0 pb-0",
            attrs: {
              "cols": "11"
            }
          }, [_c(VSkeletonLoader, {
            attrs: {
              "type": "heading"
            }
          })], 1), _c(VCol, {
            staticClass: "mt-2 mb-0 pb-0",
            attrs: {
              "cols": "1"
            }
          }, [_c(VProgressCircular, {
            attrs: {
              "color": _vm.color,
              "width": "2",
              "indeterminate": ""
            }
          })], 1), _c(VCol, {
            staticClass: "mt-2 mb-0 pb-0",
            attrs: {
              "cols": "11"
            }
          }, [_c(VSkeletonLoader, {
            attrs: {
              "type": "heading"
            }
          })], 1), _c(VCol, {
            staticClass: "mt-2 mb-0 pb-0",
            attrs: {
              "cols": "1"
            }
          }, [_c(VProgressCircular, {
            attrs: {
              "color": _vm.color,
              "width": "2",
              "indeterminate": ""
            }
          })], 1), _c(VCol, {
            staticClass: "mt-2 mb-0 pb-0",
            attrs: {
              "cols": "11"
            }
          }, [_c(VSkeletonLoader, {
            attrs: {
              "type": "heading"
            }
          })], 1), _c(VCol, {
            staticClass: "mt-2 mb-0 pb-0",
            attrs: {
              "cols": "1"
            }
          }, [_c(VProgressCircular, {
            attrs: {
              "color": _vm.color,
              "width": "2",
              "indeterminate": ""
            }
          })], 1)], 1) : _c(VRow, _vm._l(_vm.pickableTargetStates(item), function (state, j) {
            return _c(VCol, {
              key: `twin-copy-${i}-state-${j}`,
              staticClass: "py-1",
              attrs: {
                "cols": "12"
              }
            }, [_vm.pickableStates[j].properties.binding.type.startsWith('iothub') ? [_c(VTextField, {
              class: state.properties.binding.type.startsWith('iothub') ? 'required' : '',
              attrs: {
                "label": `${_vm.pickableStates[j].key} - ${_vm.$i18n_t('NiotaClassic.Common.table.eui')}`,
                "color": _vm.color,
                "outlined": _vm.inpOutlined,
                "filled": _vm.inpFilled,
                "loading": _vm.isLoadingStateData(state),
                "hint": state.deviceTitle,
                "rules": _vm.rulesForState(state),
                "readonly": !state.properties.binding.type.startsWith('iothub'),
                "clearable": state.properties.binding.type.startsWith('iothub'),
                "required": state.properties.binding.type.startsWith('iothub'),
                "prepend-inner-icon": _vm.prependIconForState(state),
                "hide-details": "auto",
                "persistent-hint": ""
              },
              on: {
                "change": function ($event) {
                  return _vm.fetchIotHubDetails(state, item);
                }
              },
              scopedSlots: _vm._u([{
                key: "append-outer",
                fn: function () {
                  return [_c(VMenu, {
                    attrs: {
                      "absolute": "",
                      "offset-y": "",
                      "close-on-content-click": false
                    },
                    scopedSlots: _vm._u([{
                      key: "activator",
                      fn: function ({
                        on
                      }) {
                        return [_c(VBtn, _vm._g({
                          attrs: {
                            "color": _vm.color,
                            "icon": "",
                            "info": ""
                          }
                        }, on), [_c(VIcon, {
                          attrs: {
                            "dark": ""
                          }
                        }, [_vm._v("fal fa-ellipsis-h")])], 1)];
                      }
                    }], null, true),
                    model: {
                      value: _vm.showOptionsMenus[`${i}_${j}`],
                      callback: function ($$v) {
                        _vm.$set(_vm.showOptionsMenus, `${i}_${j}`, $$v);
                      },
                      expression: "showOptionsMenus[`${i}_${j}`]"
                    }
                  }, [_c(VCard, [_c(VCardText, [_c(VSwitch, {
                    attrs: {
                      "disabled": state.properties.binding.type === 'no-copy',
                      "input-value": state.properties.binding.type === 'none',
                      "false-value": false,
                      "color": _vm.color,
                      "label": _vm.noSourceType,
                      "inset": "",
                      "hide-details": ""
                    },
                    on: {
                      "change": function ($event) {
                        return _vm.toggleStateBindingType(state, _vm.pickableStates[j]);
                      }
                    }
                  }), _c(VSwitch, {
                    attrs: {
                      "input-value": state.properties.binding.type === 'no-copy',
                      "false-value": false,
                      "color": _vm.color,
                      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.noStateCopy'),
                      "inset": "",
                      "hide-details": ""
                    },
                    on: {
                      "change": function ($event) {
                        return _vm.toggleStateBindingType(state, _vm.pickableStates[j], 'no-copy');
                      }
                    }
                  }), _c(VBtn, {
                    class: `v-btn-x ml-2 mr-0 mt-3 v-btn--rounded bg-rounded-button-${_vm.color}`,
                    attrs: {
                      "color": _vm.color,
                      "text": "",
                      "rounded": ""
                    },
                    on: {
                      "click": () => {
                        _vm.setIotHubEuiFromOriginalState(state, _vm.pickableStates[j]);
                      }
                    }
                  }, [_vm._v("\n                              Original\n                            ")])], 1)], 1)], 1)];
                },
                proxy: true
              }], null, true),
              model: {
                value: _vm.vModelForState(state).eui,
                callback: function ($$v) {
                  _vm.$set(_vm.vModelForState(state), "eui", typeof $$v === 'string' ? $$v.trim() : $$v);
                },
                expression: "vModelForState(state).eui"
              }
            })] : [_c(VTextField, {
              class: state.properties.binding.type.startsWith('virtual-device') ? 'required' : '',
              attrs: {
                "label": `${state.key} - ${_vm.$i18n_t('DigitalTwin.VirtualDevice.props.deviceId')}`,
                "color": _vm.color,
                "outlined": _vm.inpOutlined,
                "filled": _vm.inpFilled,
                "loading": _vm.isLoadingStateData(state),
                "hint": _vm.hintForState(state),
                "rules": _vm.rulesForState(state),
                "prepend-inner-icon": _vm.prependIconForState(state),
                "readonly": !state.properties.binding.type.startsWith('virtual-device'),
                "clearable": state.properties.binding.type.startsWith('virtual-device'),
                "required": state.properties.binding.type.startsWith('virtual-device'),
                "hide-details": "auto",
                "persistent-hint": ""
              },
              on: {
                "change": function ($event) {
                  return _vm.fetchVirtualDeviceData(state, item);
                }
              },
              scopedSlots: _vm._u([{
                key: "append-outer",
                fn: function () {
                  return [_c(VMenu, {
                    attrs: {
                      "absolute": "",
                      "offset-y": "",
                      "close-on-content-click": false
                    },
                    scopedSlots: _vm._u([{
                      key: "activator",
                      fn: function ({
                        on
                      }) {
                        return [_c(VBtn, _vm._g({
                          attrs: {
                            "color": _vm.color,
                            "icon": "",
                            "info": ""
                          }
                        }, on), [_c(VIcon, {
                          attrs: {
                            "dark": ""
                          }
                        }, [_vm._v("fal fa-ellipsis-h")])], 1)];
                      }
                    }], null, true),
                    model: {
                      value: _vm.showOptionsMenus[`${i}_${j}`],
                      callback: function ($$v) {
                        _vm.$set(_vm.showOptionsMenus, `${i}_${j}`, $$v);
                      },
                      expression: "showOptionsMenus[`${i}_${j}`]"
                    }
                  }, [_c(VCard, [_c(VCardText, [_c(VSwitch, {
                    attrs: {
                      "disabled": state.properties.binding.type === 'no-copy',
                      "input-value": state.properties.binding.type === 'none',
                      "false-value": false,
                      "color": _vm.color,
                      "label": _vm.noSourceType,
                      "inset": "",
                      "hide-details": ""
                    },
                    on: {
                      "change": function ($event) {
                        return _vm.toggleStateBindingType(state, _vm.pickableStates[j]);
                      }
                    }
                  }), _c(VSwitch, {
                    attrs: {
                      "input-value": state.properties.binding.type === 'no-copy',
                      "false-value": false,
                      "color": _vm.color,
                      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.noStateCopy'),
                      "inset": "",
                      "hide-details": ""
                    },
                    on: {
                      "change": function ($event) {
                        return _vm.toggleStateBindingType(state, _vm.pickableStates[j], 'no-copy');
                      }
                    }
                  }), _c(VBtn, {
                    class: `v-btn-x ml-2 mr-0 mt-3 v-btn--rounded bg-rounded-button-${_vm.color}`,
                    attrs: {
                      "color": _vm.color,
                      "text": "",
                      "rounded": ""
                    },
                    on: {
                      "click": () => {
                        _vm.setVirtualDeviceExternalIdFromOriginalState(state, _vm.pickableStates[j]);
                      }
                    }
                  }, [_vm._v("\n                              Original\n                            ")])], 1)], 1)], 1)];
                },
                proxy: true
              }], null, true),
              model: {
                value: _vm.vModelForState(state).vdExternalId,
                callback: function ($$v) {
                  _vm.$set(_vm.vModelForState(state), "vdExternalId", $$v);
                },
                expression: "vModelForState(state).vdExternalId"
              }
            })]], 2);
          }), 1)], 1)], 1);
        }), 1)];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": items.itemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }])
  }), !_vm.loadingStates ? _vm._l(_vm.twinCopiesData, function (twin, i) {
    return _c('span', {
      key: `twin-hidden-${i}`
    }, _vm._l(_vm.pickableTargetStates(twin), function (state, j) {
      return _c('span', {
        key: `twin-hidden-${i}-state-${j}`
      }, [state.properties.binding.type.startsWith('iothub') ? [_c(VInput, {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "rules": _vm.euiRules
        },
        model: {
          value: state.properties.binding.options.eui,
          callback: function ($$v) {
            _vm.$set(state.properties.binding.options, "eui", $$v);
          },
          expression: "state.properties.binding.options.eui"
        }
      }), _c(VInput, {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "rules": [v => !!v || 'Required']
        },
        model: {
          value: state.properties.binding.options.identifier,
          callback: function ($$v) {
            _vm.$set(state.properties.binding.options, "identifier", $$v);
          },
          expression: "state.properties.binding.options.identifier"
        }
      })] : _vm._e(), state.properties.binding.type.startsWith('virtual-device') ? [_c(VInput, {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "rules": [v => !!v || 'Required']
        },
        model: {
          value: state.properties.binding.options.virtualDevice.vDeviceStateId,
          callback: function ($$v) {
            _vm.$set(state.properties.binding.options.virtualDevice, "vDeviceStateId", $$v);
          },
          expression: "state.properties.binding.options.virtualDevice.vDeviceStateId"
        }
      })] : _vm._e()], 2);
    }), 0);
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };